/*
 * Ponte entre os cards de sections/filter-carousel.liquid (e as pills de sections/filter-pills.liquid) e o Globo Filter.
 *
 * O template do Globo (snippets/globo.filter.tree.liquid) continua renderizando o filtro
 * "promovido" no DOM, escondido via .gf-promoted (classe aplicada aqui, pois o Globo pode usar markup próprio). Aqui:
 *  - clicar num card dispara o clique no <button>/<a> equivalente da lista escondida (o Globo faz o resto);
 *  - o estado dos cards (selecionado / indisponível) é lido dessa mesma lista a cada re-render do Globo;
 *  - nas pills ([data-filter-auto]) os próprios itens também são montados a partir dessa lista.
 */
(function () {
  if (window.__filterCarouselBridge) return;
  window.__filterCarouselBridge = true;

  var norm = function (s) {
    return (s || '').trim().toLowerCase();
  };

  // Valores do filtro dentro de um bloco do Globo, ignorando o botão "Limpar" (.gf-clear) do título do bloco.
  function valueAnchors(block) {
    return Array.prototype.filter.call(block.querySelectorAll('button[aria-label], a[aria-label]'), function (a) {
      return !a.closest('.gf-block-title, .gf-clear, .gf-clear-all');
    });
  }

  function findAnchor(filterName, value) {
    var blocks = document.querySelectorAll('.gf-option-block[data-filter-type]');
    for (var i = 0; i < blocks.length; i++) {
      if (norm(blocks[i].getAttribute('data-filter-type')) !== norm(filterName)) continue;
      var anchors = valueAnchors(blocks[i]);
      for (var j = 0; j < anchors.length; j++) {
        if (norm(anchors[j].getAttribute('aria-label')) === norm(value)) return anchors[j];
      }
    }
    return null;
  }

  function filterLoaded(filterName) {
    var blocks = document.querySelectorAll('.gf-option-block[data-filter-type]');
    for (var i = 0; i < blocks.length; i++) {
      if (norm(blocks[i].getAttribute('data-filter-type')) === norm(filterName)) return true;
    }
    return false;
  }

  function hidePromoted() {
    var names = [];
    document.querySelectorAll('[data-filter-carousel]').forEach(function (root) {
      names.push(norm(root.getAttribute('data-filter-name')));
    });
    document.querySelectorAll('.gf-option-block[data-filter-type]').forEach(function (block) {
      if (names.indexOf(norm(block.getAttribute('data-filter-type'))) !== -1) {
        block.classList.add('gf-promoted');
      }
    });
  }

  function isChecked(anchor) {
    return anchor.getAttribute('aria-checked') === 'true' || anchor.classList.contains('checked');
  }

  function checkedAnchors(filterName) {
    var out = [];
    document.querySelectorAll('.gf-option-block[data-filter-type]').forEach(function (block) {
      if (norm(block.getAttribute('data-filter-type')) !== norm(filterName)) return;
      valueAnchors(block).forEach(function (a) {
        if (isChecked(a)) out.push(a);
      });
    });
    return out;
  }

  /*
   * Seleção única (data-filter-single): o Globo não expõe uma API de "radio" confiável, então
   * marcamos o valor novo e, a cada re-render do Globo, desmarcamos um dos antigos até sobrar só ele.
   * Um clique por vez: só clica de novo depois que o anterior foi aplicado (âncora trocada ou estado mudou).
   */
  function stepSingle(root) {
    var st = root.__single;
    if (!st) return;
    if (Date.now() > st.until) { root.__single = null; return; }
    if (document.contains(st.clicked) && isChecked(st.clicked) === st.clickedWas) return; // aguardando o Globo
    var name = root.getAttribute('data-filter-name');
    var target = findAnchor(name, st.target);
    if (!target || !isChecked(target)) { root.__single = null; return; }
    var others = checkedAnchors(name).filter(function (a) {
      return norm(a.getAttribute('aria-label')) !== norm(st.target);
    });
    if (!others.length) { root.__single = null; return; }
    st.clicked = others[0];
    st.clickedWas = true;
    st.until = Date.now() + 8000;
    others[0].click();
  }

  // [data-filter-auto] (sections/filter-pills.liquid): monta as pills com os valores que o Globo renderizou.
  function renderAuto(root) {
    var name = root.getAttribute('data-filter-name');
    var labels = [];
    document.querySelectorAll('.gf-option-block[data-filter-type]').forEach(function (block) {
      if (norm(block.getAttribute('data-filter-type')) !== norm(name)) return;
      valueAnchors(block).forEach(function (a) {
        var label = (a.getAttribute('aria-label') || '').trim();
        if (label && labels.indexOf(label) === -1) labels.push(label);
      });
    });
    var signature = labels.join('\n');
    if (root.__signature === signature) return;
    root.__signature = signature;

    var list = root.querySelector('[data-filter-list]');
    var tpl = root.querySelector('template[data-filter-template]');
    list.textContent = '';
    labels.forEach(function (label) {
      var item = tpl.content.firstElementChild.cloneNode(true);
      var card = item.matches('[data-filter-card]') ? item : item.querySelector('[data-filter-card]');
      card.setAttribute('data-filter-value', label);
      item.querySelector('[data-filter-label]').textContent = label;
      list.appendChild(item);
    });
    root.hidden = labels.length === 0;
  }

  function sync() {
    hidePromoted();
    document.querySelectorAll('[data-filter-carousel]').forEach(function (root) {
      if (root.hasAttribute('data-filter-auto')) renderAuto(root);
      stepSingle(root);
      var name = root.getAttribute('data-filter-name');
      var loaded = filterLoaded(name);
      var st = root.__single;
      root.querySelectorAll('[data-filter-card]').forEach(function (card) {
        var value = card.getAttribute('data-filter-value');
        var anchor = findAnchor(name, value);
        // Durante a troca na seleção única, mostra só o valor escolhido como selecionado.
        var selected = st ? norm(value) === norm(st.target) : !!anchor && isChecked(anchor);
        card.classList.toggle('is-selected', selected);
        card.setAttribute('aria-pressed', selected ? 'true' : 'false');
        // Só marca como indisponível depois que o Globo carregou o filtro.
        card.classList.toggle('is-unavailable', loaded && !anchor);
      });
    });
  }

  function activate(card) {
    var root = card.closest('[data-filter-carousel]');
    var name = root.getAttribute('data-filter-name');
    var value = card.getAttribute('data-filter-value');
    var anchor = findAnchor(name, value);
    if (!anchor) return;
    root.__single = null;
    if (root.hasAttribute('data-filter-single') && !isChecked(anchor) && checkedAnchors(name).length) {
      root.__single = { target: value, clicked: anchor, clickedWas: false, until: Date.now() + 8000 };
    }
    anchor.click();
    if (root.__single) {
      root.querySelectorAll('[data-filter-card]').forEach(function (c) {
        c.classList.toggle('is-selected', c === card);
        c.setAttribute('aria-pressed', c === card ? 'true' : 'false');
      });
    }
  }

  document.addEventListener('click', function (e) {
    var card = e.target.closest && e.target.closest('[data-filter-card]');
    if (card) activate(card);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var card = e.target.closest && e.target.closest('[data-filter-card]');
    if (!card) return;
    e.preventDefault();
    activate(card);
  });

  var pending = null;
  var schedule = function () {
    if (pending) return;
    pending = setTimeout(function () {
      pending = null;
      sync();
    }, 80);
  };
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  sync();
})();
